import { fork } from 'redux-saga/effects'

import { userSaga } from './user'
import { messageWatcher } from './message'
import { contestsSaga } from './contests'
import { couponsSaga } from './coupons'

export function* rootSaga() {
  yield fork(userSaga)
  yield fork(messageWatcher)
  yield fork(contestsSaga)
  yield fork(couponsSaga)
}
